import { Box, styled } from '@mui/material';
import React from 'react';

const Wrapper = styled(Box)(({ theme }) => ({
  padding: '20px 0',
  textAlign: 'center',
  marginTop: '-2rem',
  color: theme.palette.primary.main,
}));

type Props = {
  smBusinessInfo?: {
    smbizBusinessInvites?: {
      discountPercentage?: number;
      groupCode?: string;
    };
  };
};

const CommunityBanner: React.FC<Props> = ({ smBusinessInfo }) => {
  return (
    <Wrapper component="section">
      <b>
        You save {smBusinessInfo?.smbizBusinessInvites?.discountPercentage}% off
        any memberships with your Discount
      </b>
    </Wrapper>
  );
};

export default CommunityBanner;
